import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import DeleteProductModal from '../../../../views/product/common/modal/DeleteProductModal';
import withModal from '../../../../lib/hoc/withModal';
import { productActions } from '../../../../store/modules/product';

class DeleteProductModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //--> 상품 삭제 사유
      reason: null,
    };
  }

  /**
   * 상품 삭제 하기
   */
  onSubmit = () => {
    const { form, data, deleteProduct } = this.props;
    const { reason } = this.state;
    const { productId, productUpdateLogId } = data;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, (err) => {
      if (err) return;

      deleteProduct({
        productId,
        productUpdateLogId,
        reason,
      });

      /**
       * 모달 닫기
       */
      this.closeModal();
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'deleteProductModal', value: false });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    return (
      <DeleteProductModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.product.deleteProductModal.isOpen,
    data: state.product.deleteProductModal.data,
  };
};

const mapDispatchToProps = {
  deleteProduct: productActions.deleteProduct,
  toggleModal: productActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(Form.create({})(DeleteProductModalContainer)));
